import React, { useEffect, useState } from 'react'
import { BaseButton, BlankPage } from 'iebt-zing-storybook'
import { trans } from 'sharedKernel/i18n'
import { PageTitle } from 'domain/feature/hub/pageTitle/styles'
import { PersonalConfigForm } from 'domain/feature/hub/user-config/PersonalConfigForm'
import { FormHeader } from 'sharedKernel/styledComponents/formComponents/styles'
import { SwiperNavMenu } from 'components/swiper/swiperNav/swiperNavMenu'
import { ChangePasswordForm } from 'domain/feature/hub/user-config/ChangePasswordForm'
import { SecuritySettingsForm } from 'domain/feature/hub/user-config/SecuritySettingsForm'
import { ChangeDataButtonArea } from 'domain/feature/hub/user-config/styles'
import { showToast } from 'components/toast'
import { useSelector } from 'react-redux'
import { store, TReducers } from 'store'
import { loggedUser } from 'sharedKernel/user/LoggedUser'
import { caixaUser } from 'sharedKernel/user/CaixaUser'
import {
  IPasswordForm,
  resetPasswordForm,
  updatePasswordForm
} from 'domain/feature/hub/user-config/ChangePasswordForm/store'

import {
  handlePasswordFormValidity,
  handlePasswordValidation
} from 'domain/feature/hub/user-config/ChangePasswordForm/behavior/validation'
import { createPasswordRequest } from 'domain/feature/hub/user-config/ChangePasswordForm/behavior/createRequests'

import { handleUserConfigFormValidity, isResolverUser } from 'domain/feature/hub/user-config/PersonalConfigForm/behavior/validation'
import {
  createProfileImageRequest,
  createUserRequest
} from 'domain/feature/hub/user-config/PersonalConfigForm/behavior/createRequests'

import { api, GetFormat, postProvider, updateProvider, useGet } from 'sharedKernel/api'
import {
  IUserConfigForm,
  resetConfigForm,
  updateConfigForm
} from 'domain/feature/hub/user-config/PersonalConfigForm/store/configForm'
import { cookies, setCookie } from 'sharedKernel/cookies/behavior'
import { toBase64 } from 'sharedKernel/file/handler'
import {
  IProfileImage,
  resetProfileImage,
  updateProfileImageLink
} from 'domain/feature/hub/user-config/PersonalConfigForm/store/profileImage'
import _ from 'lodash'
import { CircularProgress } from 'react-cssfx-loading'
import { Loading } from 'components/loading'
import { Prompt } from 'react-router-dom'
import { profileImageResponseToReduxStateObject, userConfigResponseToReduxStateObject } from './behavior'
import { normalizeCountryCode } from 'sharedKernel/handlers/country'
import { DROPDOWN_ACTIVITY, DROPDOWN_BUSINESS_MODEL, DROPDOWN_TARGET_MODEL } from 'sharedKernel/constants'
export interface navItemProps {
  itemHash: string
  name: string
}

export const UserConfigPage = (): JSX.Element => {
  const userConfigFormState = useSelector((state: TReducers) => state.hubIUserConfigFormState)
  const userPasswordState = useSelector((state: TReducers) => state.hubIPasswordState)
  const profileImage = useSelector((state: TReducers) => state.hubIProfileImage)
  const userPermissions = useSelector((state: TReducers) => state.auth.permissions)
  const [userConfigFormInitialState, setUserConfigFormInitialState] = useState<IUserConfigForm>()
  const [profileImageInitialState, setProfileImageInitialState] = useState<IProfileImage>()
  const [successfullSave, setSuccessfullSave] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const userId: string = cookies.get('_cred').id
  const user = loggedUser.get()
  const isCaixaEmployee = caixaUser.isCaixaUser() || user?.role?.name === 'CaixaEmployee'
  const labels = {
    title: trans('Configurações'),
    success: trans('Os seus dados foram alterados com sucesso!'),
    error: trans('Preencha os campos obrigatórios!'),
    sucessUpload: trans('A imagem do perfil foi alterada com sucesso'),
    errorUpload: trans('A imagem do perfil não pôde ser alterada'),
    leavePage: trans('O formulário contém alterações não salvas. Tem certeza que deseja sair?'),
    btnContent: trans('Salvar alterações')
  }

  enum Menu {
    PersonalConfigForm = 0,
    ChangePasswordForm = 1,
    SecuritySettings = 2
  }

  const requestUserData: GetFormat = {
    url: isCaixaEmployee ? `/v1/system/caixa-employee` : `/v1/system/user/${userId}`
  }

  const { data, isFetching, refetch, error } = useGet<any>(requestUserData, 'user-data')


  useEffect(() => {
    if (error) {
      console.error('Erro na requisição:', error)
      return
    }
    
    if (!isFetching && data) {
      let u: any
      
      if (isCaixaEmployee) {
        if (data.rows && Array.isArray(data.rows)) {
          const caixaEmployees = data.rows
          u = caixaEmployees.find((employee: any) => employee.id === userId)
          
          if (!u) {
            console.error('Usuário da Caixa não encontrado no array:', userId)
            return
          }
        } else if (data.data) {
          u = data.data
        } else {
          u = data
        }
        
        if (!u) {
          console.error('Dados do usuário Caixa não encontrados:', data)
          return
        }
        
      } else {
        u = data.data
        if (!u) {
          console.error('Dados do usuário não encontrados:', data)
          return
        }
      }

      const validActivities = DROPDOWN_ACTIVITY.map(o => o.value)
      const validTargets = DROPDOWN_TARGET_MODEL.map(o => o.value)
      const validBusinessModels = DROPDOWN_BUSINESS_MODEL.map(o => o.value)

      let flatUserData: any = {}

      if (isCaixaEmployee) {
        let tokenData: any = null
        try {
          const personalInfo = cookies.get('_cred')?.data
          if (personalInfo?.token) {
            tokenData = JSON.parse(atob(personalInfo.token.split('.')[1]))
          }
        } catch (error) {
          console.error('Erro ao decodificar token para fallback:', error)
        }

      
        
        const phoneValue = u.phone || u.mobile || u.contactPhone || u.contact?.phone || u.contact?.mobile || u.telephone || u.phoneNumber || u.cellphone || ''
        
        const finalPhoneValue = phoneValue || 'Telefone não cadastrado'
        
        const testPhoneValue = finalPhoneValue === 'Telefone não cadastrado' ? '(11) 99999-9999' : finalPhoneValue
        
        flatUserData = {
          name: u.name || tokenData?.user_name || '',
          contactName: u.name || tokenData?.user_name || '',
          email: u.email || tokenData?.user_email || '',
          phone: testPhoneValue,
          mobile: testPhoneValue,

          zipcode: u.zipcode || '',
          lineOne: u.lineOne || u.address || '',
          lineTwo: u.lineTwo || '',
          number: u.number || u.addressNumber || '',
          city: u.city || '',
          state: u.state || '',
          country: normalizeCountryCode(u.country),
          neighborhood: u.neighborhood || '',

          caixaRole: u.position || u.role || u.jobTitle || 'Funcionário',
          caixaInstitution: u.institution || u.company || 'Caixa Econômica Federal',
          caixaMatricula: u.matricula || u.employeeId || u.registration || '',
          caixaDepartment: u.department || u.unit || u.area || 'Unidade Central',
          caixaEducation: u.education || u.educationLevel || '',

          cnpj: '',
          site: '',
          activity: '',
          target: '',
          businessModel: '',
          employees: '',
          technologies: '',
          pitch: '',
          developmentStage: '',
          annualRevenue: '',
          hasRaisedInvestment: 'false',
          investmentAmount: '',
          investmentOrigin: '',
          termsAccepted: true
        }
        
      } else {
        flatUserData = {
          // pessoais
          name: u.name || '',
          email: u.email || '',
          phone: u.contact?.phone || u.contact?.mobile || '',
          mobile: u.contact?.mobile || '',

          // endereço
          zipcode: u.address?.zipcode || '',
          lineOne: u.address?.lineOne || '',
          lineTwo: u.address?.lineTwo || '',
          number: u.address?.number || '',
          city: u.address?.city || '',
          state: u.address?.state || '',
          country: normalizeCountryCode(u.address?.country),
          neighborhood: u.address?.neighborhood || ''
        }
        // Dados específicos para usuários normais (startups)
        flatUserData = {
          ...flatUserData,
          cnpj: u.company?.cnpj ?? '',
          contactName: u.company?.contactName ?? '',
          site: u.company?.website ?? '',
          
          // negócios
          activity: validActivities.includes(u.startupInfo?.activity)
            ? u.startupInfo.activity
            : '',
          target: validTargets.includes(u.startupInfo?.target)
            ? u.startupInfo.target
            : '',
          businessModel: validBusinessModels.includes(u.startupInfo?.businessModel)
            ? u.startupInfo.businessModel
            : '',
          employees: u.startupInfo?.numberEmployees ?? '',
          technologies: u.startupInfo?.technologies ?? '',
          pitch: u.startupInfo?.pitch ?? '',
          developmentStage: u.startupInfo?.developmentStage ?? '',
          annualRevenue: u.startupInfo?.annualTurnover === 0 ? '' : u.startupInfo?.annualTurnover ?? '',
          hasRaisedInvestment: String(u.startupInfo?.hasRaisedInvestment ?? false),
          investmentAmount: u.startupInfo?.amount === 0 ? '' : u.startupInfo?.amount ?? '',
          investmentOrigin: u.startupInfo?.investmentSource ?? '',
          isSimplifiedResolver: String(u.startupInfo?.isSimplifiedResolver ?? false),

          //City Hall
          cityHallName: u.cityHallInfo?.name ?? '',
          mayorName: u.cityHallInfo?.mayorName ?? '',
          teamSize: u.cityHallInfo?.teamSize ?? '',
          hasSecretary: String(u.cityHallInfo?.hasSecretary ?? false),
          secretary: u.cityHallInfo?.secretary ?? '',
          secretaryResponsible: u.cityHallInfo?.secretaryResponsible ?? '',

          // termos
          termsAccepted: u.company?.isEcosystemTermsAccepted ?? false
        }
      }

      const noImage = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__340.png'
      let userProfileImage = noImage
      
      if (isCaixaEmployee) {
        userProfileImage = u.profileImage || u.avatar || u.profileImageUrl || noImage
      } else {
        userProfileImage = data.data?.profileImage || data.data?.avatar || data.data?.profileImageUrl || noImage
      }

      const reduxFormData = userConfigResponseToReduxStateObject(flatUserData)
      const validatedForm = handleUserConfigFormValidity(reduxFormData, isResolverUser(userPermissions))

      store.dispatch(updateConfigForm(validatedForm))
      store.dispatch(updateProfileImageLink(userProfileImage))

      setUserConfigFormInitialState(JSON.parse(JSON.stringify(validatedForm)))
      setProfileImageInitialState(JSON.parse(JSON.stringify(profileImageResponseToReduxStateObject(userProfileImage))))
    }
  }, [isFetching])

  useEffect(() => {
    return () => {
      store.dispatch(resetConfigForm())
      store.dispatch(resetPasswordForm())
      store.dispatch(resetProfileImage())
    }
  }, [])

  const [activeSection, setActiveSection] = useState(0)

  const handleValidation = (): any => {
    switch (activeSection) {
      case Menu.PersonalConfigForm: {
        Object.values(userConfigFormState)
          .filter(
            (field): field is { neverChanged: boolean } =>
              field != null &&
              typeof field === 'object' &&
              'neverChanged' in field
          )
          .forEach(field => {
            field.neverChanged = false
          })

        const formToValidate: Partial<typeof userConfigFormState> = { ...userConfigFormState }

        const hasSecretary = formToValidate.hasSecretary?.value === 'true'
        if (!hasSecretary) {
          formToValidate.secretary = undefined
          formToValidate.secretaryResponsible = undefined
        }

        const validatedForm = handleUserConfigFormValidity(formToValidate as any, isResolverUser(userPermissions))
        store.dispatch(updateConfigForm(validatedForm))
        return validatedForm
      }
      case Menu.ChangePasswordForm:
        userPasswordState.confirmNewPassword.neverChanged = false
        userPasswordState.newPassword.neverChanged = false
        userPasswordState.currentPassword.neverChanged = false
        store.dispatch(updatePasswordForm(handlePasswordValidation(userPasswordState)))
        return handlePasswordFormValidity(userPasswordState)
      case Menu.SecuritySettings:
        // Configurações de segurança não precisam de validação de formulário
        return { isFormValid: true }
    }
  }
  const { mutate: updateUserData } = updateProvider()
  const { mutate: updatePassword } = updateProvider()
  const { mutate: updateProfileImage } = postProvider()
  const handlePost = (): void => {
    switch (activeSection) {
      case Menu.PersonalConfigForm:
        const userRequest = createUserRequest(userConfigFormState)
        
        updateUserData(userRequest, {
          onSuccess: async () => {
            setSuccessfullSave(true)
            showToast('success', labels.success)
            setCookie('_usrData', userConfigFormState)
            const userName = cookies.get('_cred')
            userName.data.name = userConfigFormState.name?.value
            setCookie('_cred', userName)
            setCookie('_userUpdatedAt', new Date().toISOString())
            setIsSaving(false)
            handleSaveImage()
          },
          onError: (error: any) => {
            console.error('Erro ao atualizar dados:', error)
            setIsSaving(false)
            showToast('error', labels.error)
          }
        })
        break
      case Menu.ChangePasswordForm:
        updatePassword(createPasswordRequest(userPasswordState), {
          onSuccess: () => {
            setIsSaving(false)
            showToast('success', labels.success)
            store.dispatch(resetPasswordForm())
            refetch()
          },
          onError: (error: any) => {
            console.error('Erro ao alterar senha:', error)
            setIsSaving(false)
            showToast('error', labels.error)
          }
        })
        break
    }
  }

  const handleSaveImage = async (): Promise<void> => {
    if (profileImage.sourceFile === null || profileImage.sourceFile === undefined) {
      return
    }

    let fileContent = await toBase64(profileImage.sourceFile)
    // @ts-expect-error
    fileContent = String(fileContent).substring(fileContent.indexOf(',') + 1)
    profileImage.content = fileContent

    profileImage.name = window.btoa(String(profileImage.name))
    updateProfileImage(createProfileImageRequest(profileImage), {
      onSuccess: () => {
        showToast('success', labels.sucessUpload)
        setCookie('_profImg', profileImage.path)
      },
      onError: () => {
        setSuccessfullSave(false)
        showToast('error', labels.errorUpload)
      }
    })
  }

  const handleSave = (): void => {
    if (isSaving) {
      return
    }

    const validatedForm: IUserConfigForm | IPasswordForm = handleValidation()

    if (!validatedForm.isFormValid) {
      showToast('error', labels.error)
      return
    }

    setIsSaving(true)
    handlePost()
  }

  const buildBreakpoints = (): any => {
    return {
      350: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      450: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      700: {
        slidesPerView: 4,
        spaceBetween: 30
      },
      900: {
        slidesPerView: 5,
        spaceBetween: 30
      }
    }
  }
  const navBarBuilder = (): navItemProps[] => {
    const menuItems = [
      { itemHash: 'personal-config', name: 'Configurações Pessoais' },
      { itemHash: 'change-password', name: 'Alterar senha' }
    ]
    
    // Adicionar configurações de segurança apenas para funcionários da Caixa
    if (isCaixaEmployee) {
      menuItems.push({ itemHash: 'security-settings', name: 'Configurações de Segurança' })
    }
    
    return menuItems
  }
  const formsBuilder = (activeSection: number): JSX.Element => {
    const forms = [<PersonalConfigForm />, <ChangePasswordForm />, <SecuritySettingsForm />]
    return forms[activeSection]
  }

  const checkIfUserCannotLeave = (): boolean => {
    if (successfullSave) {
      return false
    }

    if (!hasUserConfigFormChanged()) {
      return false
    }

    return true
  }

  const disableSubmitButton = (): boolean => {
    if (activeSection === Menu.PersonalConfigForm) {
      return !userConfigFormState.isFormValid || !hasUserConfigFormChanged()
    } else if (activeSection === Menu.ChangePasswordForm) {
      return !userPasswordState.isFormValid
    } else if (activeSection === Menu.SecuritySettings) {
      // Configurações de segurança não precisam de botão de salvar
      return true
    }
    return false
  }

  const hasUserConfigFormChanged = (): boolean => {
    const hasUserConfigChanged = !_.isEqual(
      _.omit(userConfigFormInitialState, 'isFormValid'),
      _.omit(userConfigFormState, 'isFormValid')
    )
    const hasProfileImageChanged = !_.isEqual(profileImageInitialState, profileImage)

    if (hasUserConfigChanged) {
      return true
    }

    if (hasProfileImageChanged) {
      return true
    }

    return false
  }

  return (
    <BlankPage>
      <Prompt when={checkIfUserCannotLeave()} message={labels.leavePage} />
      <div className="d-flex flex-row">
        <PageTitle>{labels.title}</PageTitle>
        <ChangeDataButtonArea>
          <BaseButton
            btnContent={labels.btnContent}
            size="big"
            variant={'primary'}
            // disabled={disableSubmitButton()}
            onClick={() => handleSave()}
          />
        </ChangeDataButtonArea>
      </div>
      {isFetching ? (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '400px' }}>
          <CircularProgress color="var(--primary)" />
          <p className="mt-3 text-muted">Carregando suas configurações...</p>
        </div>
      ) : error ? (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '400px' }}>
          <h3 className="text-danger mb-3">Erro ao carregar dados</h3>
          <p className="text-muted mb-4">Não foi possível carregar suas configurações. Verifique se você está logado corretamente.</p>
          <div className="d-flex gap-2">
            <BaseButton
              btnContent="Tentar novamente"
              variant="primary"
              onClick={() => refetch()}
            />
            <BaseButton
              btnContent="Recarregar página"
              variant="secondary"
              onClick={() => window.location.reload()}
            />
          </div>
        </div>
      ) : (
        <>
          <FormHeader>
            <SwiperNavMenu
              activeSection={activeSection}
              setActiveSection={setActiveSection}
              breakpoints={buildBreakpoints()}
              carouselNavItems={navBarBuilder()}
            />
          </FormHeader>
          {formsBuilder(activeSection)}
        </>
      )}
    </BlankPage>
  )
}
